import { Component, Prop, h } from '@stencil/core';

import AbsIcon from '../svg/ABS';
import AccidentsFoundHistoryReport from '../svg/AccidentsFoundHistoryReport';
import AirbagsIcon from '../svg/Airbags';
import AlertInfo from '../svg/AlertInfo';
import Alert from '../svg/Alert';
import AppleWalletBadge from '../svg/AppleWalletBadge';
import BatteryElectricalIcon from '../svg/BatteryElectrical';
import BreadCrumbCompleted from '../svg/BreadCrumbCompleted';
import BreadCrumbCurrent from '../svg/BreadCrumbCurrent';
import BreadCrumbStep from '../svg/BreadCrumbStep';
import Car from '../svg/Car';
import CarDriverIcon from '../svg/CarDriver';
import CarFrontIcon from '../svg/CarFront';
import CarPassengerIcon from '../svg/CarPassenger';
import CarRearIcon from '../svg/CarRear';
import CarValueIcon from '../svg/CarValue';
import CheckEngineIcon from '../svg/CheckEngine';
import CheckMarkIcon from '../svg/CheckMark';
import CircledCheckMarkIcon from '../svg/CircledCheckMark';
import ConfigDrivetrain2WD from '../svg/ConfigDrivetrain2WD';
import ConfigDrivetrain4WD from '../svg/ConfigDrivetrain4WD';
import ConfigDrivetrainRWD from '../svg/ConfigDrivetrainRWD';
import ConfigEngine from '../svg/ConfigEngine';
import ConfigTransmission from '../svg/ConfigTransmission';
import Currency from '../svg/Currency';
import DashLightsIcon from '../svg/DashboardLights';
import EngineIcon from '../svg/Engine';
import ExhaustIcon from '../svg/Exhaust';
import ExternalLink from '../svg/ExternalLink';
import FrameStructuralIcon from '../svg/FrameStructural';
import GlobeIcon from '../svg/Globe';
import GreenCheckButton from '../svg/GreenCheckButton';
import HeatingAirConditioningIcon from '../svg/HeatingAirConditioning';
import IconAlert from '../svg/IconAlert';
import ImageCaptureAlert from '../svg/ImageCaptureAlert';
import ImageCaptureCheckMark from '../svg/ImageCaptureCheckMark';
import ImageCaptureCrossMark from '../svg/ImageCaptureCrossMark';
import ImageCaptureDashboard from '../svg/ImageCaptureDashboard';
import ImageCaptureDriver from '../svg/ImageCaptureDriver';
import ImageCaptureFront from '../svg/ImageCaptureFront';
import ImageCapturePassenger from '../svg/ImageCapturePassenger';
import ImageCaptureRear from '../svg/ImageCaptureRear';
import ImageCaptureSeating from '../svg/ImageCaptureSeating';
import ImageCaptureTrash from '../svg/ImageCaptureTrash';
import JeepDriverIcon from '../svg/JeepDriver';
import JeepFrontIcon from '../svg/JeepFront';
import JeepPassengerIcon from '../svg/JeepPassenger';
import JeepRearIcon from '../svg/JeepRear';
import KbbValuesLogo from '../svg/KbbValuesLogo';
import KbycLogo from '../svg/KbycLogo';
import KelleyBuysYourCar from '../svg/KelleyBuysYourCar';
import LoaderBarIconsCompleted from '../svg/LoaderBarIconsCompleted';
import LoaderIconsBar from '../svg/LoaderIconsBar';
import Logo from '../svg/Logo';
import LowCoolantIcon from '../svg/LowCoolant';
import MailIcon from '../svg/Mail';
import MaintenanceIcon from '../svg/Maintenance';
import MapMarkerIcon from '../svg/MapMarker';
import MultipleAccidentsIcon from '../svg/MultipleAccidents';
import MultipleOwnersIcon from '../svg/MultipleOwners';
import MultipleOwnersHistoryReport from '../svg/MultipleOwnersHistoryReport';
import NewBadge from '../svg/NewBadge';
import NoAccidentsIcon from '../svg/NoAccidents';
import NoAccidentsHistoryReport from '../svg/NoAccidentsHistoryReport';
import NonRentalIcon from '../svg/NonRental';
import NonRentalHistoryReport from '../svg/NonRentalHistoryReport';
import OdometerIcon from '../svg/Odometer';
import OilPressureIcon from '../svg/OilPressure';
import OneOwnerIcon from '../svg/OneOwner';
import OneOwnerHistoryReport from '../svg/OneOwnerHistoryReport';
import Performance from '../svg/Performance';
import ModificationsIcon from '../svg/PerformanceMod';
import PersonIcon from '../svg/Person';
import PhoneIcon from '../svg/Phone';
import PhoneDealer from '../svg/PhoneDealer';
import PhoneOutlineIcon from '../svg/PhoneOutline';
import PlayButton from '../svg/PlayButton';
import PriorRentalIcon from '../svg/PriorRental';
import PriorRentalHistoryReport from '../svg/PriorRentalHistoryReport';
import QuestionCircleIcon from '../svg/QuestionCircle';
import RoundCheckMarkIcon from '../svg/RoundCheckMark';
import SeatsCarpetHeadIcon from '../svg/SeatsCarpetHeadliner';
import SkeletonLoadingImage from '../svg/SkeletonLoadingImage';
import SteeringWheelIcon from '../svg/SteeringWheel';
import StereoIcon from '../svg/Stereo';
import SunroofMoonroofIcon from '../svg/SunroofMoonroof';
import SuspensionIcon from '../svg/Suspension';
import SUVDriverIcon from '../svg/SuvDriver';
import SUVFrontIcon from '../svg/SuvFront';
import SUVPassengerIcon from '../svg/SuvPassenger';
import SUVRearIcon from '../svg/SuvRear';
import TransmissionIcon from '../svg/Transmission';
import TruckDriverIcon from '../svg/TruckDriver';
import TruckFrontIcon from '../svg/TruckFront';
import TruckPassengerIcon from '../svg/TruckPassenger';
import TruckRearIcon from '../svg/TruckRear';
import WheelsTiresIcon from '../svg/WheelsTires';
import WheresMyVin from '../svg/WheresMyVin';
import WindowsLightsIcon from '../svg/WindowsLights';
import XIcon from '../svg/XIcon';
import YourLocation from '../svg/YourLocation';
import YourTradeIn from '../svg/YourTradeIn';
import YourVehicleOfInterest from '../svg/YourVehicleOfInterest';

@Component({
  tag: 'svg-icon',
  styleUrl: 'svg-icon.css',
  shadow: true,
})
export class SvgIcon {
  @Prop() icon: string = '';
  @Prop() height: string = '100%';
  @Prop() width: string = '100%';
  @Prop() input: string = '';
  @Prop() theme: string = '';

  private iconMap = {
    '': '',
    abs: AbsIcon,
    airbags: AirbagsIcon,
    'alert-info': AlertInfo,
    'alert': Alert,
    'accidents-found-history-report': AccidentsFoundHistoryReport,
    'apple-wallet-badge': AppleWalletBadge,
    battery: BatteryElectricalIcon,
    'breadcrumb-completed': BreadCrumbCompleted,
    'breadcrumb-current': BreadCrumbCurrent,
    'breadcrumb-step': BreadCrumbStep,
    'car-driver': CarDriverIcon,
    'car-passenger': CarPassengerIcon,
    'car-front': CarFrontIcon,
    'car-rear': CarRearIcon,
    'car-value': CarValueIcon,
    'check-engine': CheckEngineIcon,
    'check-mark': CheckMarkIcon,
    'round-check-mark': RoundCheckMarkIcon,
    'circled-check-mark': CircledCheckMarkIcon,
    'green-check-button': GreenCheckButton,
    'config-drivetrain-2wd': ConfigDrivetrain2WD,
    'config-drivetrain-4wd': ConfigDrivetrain4WD,
    'config-drivetrain-awd': ConfigDrivetrain4WD,
    'config-drivetrain-fwd': ConfigDrivetrain2WD,
    'config-drivetrain-rwd': ConfigDrivetrainRWD,
    'config-engine': ConfigEngine,
    'config-transmission': ConfigTransmission,
    currency: Currency,
    'dash-lights': DashLightsIcon,
    engine: EngineIcon,
    exhaust: ExhaustIcon,
    frame: FrameStructuralIcon,
    globe: GlobeIcon,
    hvac: HeatingAirConditioningIcon,
    'jeep-driver': JeepDriverIcon,
    'jeep-passenger': JeepPassengerIcon,
    'jeep-front': JeepFrontIcon,
    'jeep-rear': JeepRearIcon,
    'kbyc-logo': KbycLogo,
    'kelley-buys': KelleyBuysYourCar,
    'low-coolant': LowCoolantIcon,
    'map-marker': MapMarkerIcon,
    maintenance: MaintenanceIcon,
    modifications: ModificationsIcon,
    'multiple-accidents': MultipleAccidentsIcon,
    'multiple-owners': MultipleOwnersIcon,
    'multiple-owners-history-report': MultipleOwnersHistoryReport,
    'new-badge': NewBadge,
    'no-accidents': NoAccidentsIcon,
    'non-rental': NonRentalIcon,
    'no-accidents-history-report': NoAccidentsHistoryReport,
    'non-rental-history-report': NonRentalHistoryReport,
    'oil-pressure': OilPressureIcon,
    odometer: OdometerIcon,
    'one-owner': OneOwnerIcon,
    'one-owner-history-report': OneOwnerHistoryReport,
    performance: Performance,
    person: PersonIcon,
    phone: PhoneIcon,
    'prior-rental': PriorRentalIcon,
    'prior-rental-history-report': PriorRentalHistoryReport,
    'service-engine': EngineIcon,
    steering: SteeringWheelIcon,
    stereo: StereoIcon,
    sunroof: SunroofMoonroofIcon,
    suspension: SuspensionIcon,
    sch: SeatsCarpetHeadIcon,
    'suv-driver': SUVDriverIcon,
    'suv-passenger': SUVPassengerIcon,
    'suv-front': SUVFrontIcon,
    'suv-rear': SUVRearIcon,
    transmission: TransmissionIcon,
    'truck-driver': TruckDriverIcon,
    'truck-passenger': TruckPassengerIcon,
    'truck-front': TruckFrontIcon,
    'truck-rear': TruckRearIcon,
    undefined: '',
    'windows-lights': WindowsLightsIcon,
    wheels: WheelsTiresIcon,
    'wheres-my-vin': WheresMyVin,
    'image-capture-checkmark': ImageCaptureCheckMark,
    'image-capture-crossmark': ImageCaptureCrossMark,
    'image-capture-driver': ImageCaptureDriver,
    'image-capture-passenger': ImageCapturePassenger,
    'image-capture-front': ImageCaptureFront,
    'image-capture-rear': ImageCaptureRear,
    'image-capture-dashboard': ImageCaptureDashboard,
    'image-capture-seating': ImageCaptureSeating,
    'image-capture-alert': ImageCaptureAlert,
    'image-capture-trash': ImageCaptureTrash,
    x: XIcon,
    'skeleton-loading-image': SkeletonLoadingImage,
    'play-button': PlayButton,
    'phone-outline': PhoneOutlineIcon,
    mail: MailIcon,
    'question-circle': QuestionCircleIcon,
    'loader-bar-icons-completed': LoaderBarIconsCompleted,
    'loader-bar-icons': LoaderIconsBar,
    'icon-alert': IconAlert,
    logo: Logo,
    'kbb-values-logo': KbbValuesLogo,
    'your-location': YourLocation,
    'your-trade-in': YourTradeIn,
    'your-vehicle-of-interest': YourVehicleOfInterest,
    car: Car,
    'phone-dealer': PhoneDealer,
    'external-link': ExternalLink,
  };

  render() {
    const SVG = this.iconMap[this.icon];

    return (
      <div class={`${this.theme}-theme`}>
        <SVG width={this.width} height={this.height} input={this.input} />
      </div>
    );
  }
}
